(() => {
  const selector = '[data-otd-tactile-hero]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const initHero = (root) => {
    if (!root || root.dataset.otdHeroReady === 'true') return;
    root.dataset.otdHeroReady = 'true';

    const showroom = root.querySelector('.otd-tactile-hero__showroom');
    const products = [...root.querySelectorAll('.otd-tactile-hero__product')];
    let frame;

    const reset = () => {
      window.cancelAnimationFrame(frame);
      products.forEach((product) => {
        product.style.removeProperty('--drift-x');
        product.style.removeProperty('--drift-y');
      });
      root.style.removeProperty('--light-x');
      root.style.removeProperty('--light-y');
    };

    if (!showroom || root.dataset.parallax !== 'true') return;

    showroom.addEventListener('pointermove', (event) => {
      if (reducedMotion.matches || !finePointer.matches) return;
      const bounds = showroom.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width;
      const y = (event.clientY - bounds.top) / bounds.height;
      const offsetX = x - 0.5;
      const offsetY = y - 0.5;

      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        products.forEach((product) => {
          const strength = Number(product.dataset.drift) || 0;
          product.style.setProperty('--drift-x', `${offsetX * strength}px`);
          product.style.setProperty('--drift-y', `${offsetY * strength}px`);
        });
        root.style.setProperty('--light-x', `${x * 100}%`);
        root.style.setProperty('--light-y', `${y * 100}%`);
      });
    });

    showroom.addEventListener('pointerleave', reset);
    reducedMotion.addEventListener?.('change', reset);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(selector)) initHero(scope);
    scope.querySelectorAll?.(selector).forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
